export const reportedUserStatus = [
  { value: '', label: 'Select Status ' },
  { value: 'suspended', label: 'Suspended' },
  { value: 'blocked', label: 'Blocked' }
]
